import { BaseField } from "@bleu.builders/ui";
import React from "react";
import { useLoaderData, useParams } from "react-router";

import { SettingsCard } from "#/components/SettingsCard";
import { replaceParams } from "#/lib/pagesHelper";

const fields = [
  {
    name: "title",
    label: "Título",
    description: "Título do evento",
    type: "input",
    required: true,
  },
  {
    name: "description",
    label: "Descrição",
    description: "Descrição do evento que aparecerá como resumo na página",
    type: "input",
    required: true,
  },
  {
    name: "content",
    label: "Conteúdo",
    description: "Conteúdo do evento",
    type: "wysiwyg",
    required: true,
  },
] as BaseField[];

interface NewEventProps {
  actionPath: string;
}

export const NewEvent: React.FC<NewEventProps> = ({ actionPath }) => {
  const data = useLoaderData() as { data?: Record<string, unknown> };

  const params = useParams();

  return (
    <div className="my-8 space-y-4">
      <SettingsCard
        defaultValues={data?.data || {}}
        fields={fields}
        title="Criar Evento"
        action={{ path: replaceParams(actionPath, params) }}
      />
    </div>
  );
};
